import Vue from 'vue'
import Vuex from 'vuex'
import { login, logout, getInfo } from "../api/ruoyi";
import { getToken, removeToken, setExpiresIn, setToken } from "../utils/auth";

// 安装插件
Vue.use(Vuex)
let picURL = localStorage.getItem('picURL'),
  webSocket = localStorage.getItem('webSocket')
export default new Vuex.Store({
  state: {
    baseURL: picURL,
    wbskiddk: webSocket,
    token: getToken(),
    name: '',
    videoStatus: '',
    routes: 3
  },
  mutations: {
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_EXPIRES_IN: (state, time) => {
      state.expires_in = time
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_VIDEO_STATUS: (state, videostatus) => {
      state.videoStatus = videostatus
    },
    SET_ROUTES: (state, routes) => {
      state.routes = routes
    }
  },
  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const that = this;
      return new Promise((resolve, reject) => {
        login(username, password).then(res => {
          let data = res.data
          setToken(data.access_token)
          // localStorage.setItem("SET_TOKEN",data)
          // sessionStorage.setItem('SET_TOKEN',data.access_token)
          commit('SET_TOKEN', data.access_token)
          setExpiresIn(data.expires_in)
          commit('SET_EXPIRES_IN', data.expires_in)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // // 获取用户信息
    // GetInfo({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     getInfo().then(res => {
    //       const user = res.user
    //       const avatar = (user.avatar == "" || user.avatar == null) ? require("@/assets/img/profile.jpg") : user.avatar;
    //       commit('SET_NAME', user.userName)
    //       commit('SET_AVATAR', avatar)
    //       resolve(res)
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js